var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isReady)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}]},[_c('input',{ref:"input",staticClass:"filter-list livedata-filter",attrs:{"aria-label":this.$t('livedata.filter.list.label')},domProps:{"value":_vm.value}})]):_c('XWikiLoader')
}
var staticRenderFns = []

export { render, staticRenderFns }